var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custimize-iframe"},[_c('div',{staticClass:"iframe-cont"},[_c('iframe',{attrs:{"src":`https://ai.tcmcds.com/zhGraph/res/content_bzy.html?keywords=${_vm.keywords}`,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }